import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { CaseModel } from '@app/ps/models/case.model';

@Component({
  selector: 'form-expropriation-interim-decision-request',
  templateUrl: './form-expropriation-interim-decision-request.component.html',
})
export class FormExpropriationInterimDecisionRequestComponent implements OnInit {
  @Output()
  callbackRegister = new EventEmitter();
  @Input() data: CaseModel;

  constructor() {
    this.isValid = this.isValid.bind(this);
  }

  ngOnInit() {
    this.data.expropriationInterimDecisionRequestDate = new Date();
    this.callbackRegister.emit({
      isValid: this.isValid,
    });
  }

  isValid() {
    return !!this.data.expropriationInterimDecisionRequestDate;
  }
}

